// Setup: welches Gerät erkannt wurde und, wo möglich, „Als App installieren“.
import { h, type VNode } from 'snabbdom';
import { currentDevice } from '../device';
import { t } from '../i18n';
import { canInstall, install, isStandalone, needsIosHint } from '../install';

export function deviceBox(redraw: () => void): VNode {
  return h('div.setup', [
    h('div.hd', h('h3', t('Dieses Gerät'))),
    h('div.fld', [
      h('div.row', [h('span', currentDevice())]),
      isStandalone() ? h('p.muted.small', t('Läuft als installierte App.'))
        : canInstall() ? h('div.row', h('button.btn.accent', { on: { click: () => void install(redraw) } }, t('Als App installieren')))
          : needsIosHint() ? h('p.muted.small', t('Als App: in Safari „Teilen“, dann „Zum Home-Bildschirm“.'))
            : h('p.muted.small', t('Als App installieren geht in Chrome und Edge über das Menü, sobald der Server über https oder als localhost erreichbar ist.')),
    ]),
  ]);
}
